import { render, staticRenderFns } from "./HeroModule.vue?vue&type=template&id=0322a09a&"
import script from "./HeroModule.ts?vue&type=script&lang=ts&"
export * from "./HeroModule.ts?vue&type=script&lang=ts&"
import style0 from "./HeroModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports